import React, { Fragment } from 'react'
import logo from "../../Assets/images/approved_logo.jpg" ;
import CustomTitle from '../CustomTitle/CustomTitle.jsx';



export default function MonthProfile() {
   return (
      <Fragment>
         <CustomTitle title="اليروفايلات الشهرية " />

         <div className="container">
            <h2 className='main-header mt-5 pt-5'>Month Profile</h2>
            <div className='under-header'></div>
            
            <div className="row">
               <p>Not Found Data Today`s</p>
            </div>
         </div>
      </Fragment>
   )
}
